import { useEnabledFeatures } from '../../../../common/hooks/enabled-features/use-enabled-features';
import { TabBody } from '../../../../panels/entity-panels/tabs/tab-body';
import { useSelectedLocation } from '../../hooks/use-selected-location';
import { DuplicateEventsSection } from './sections/duplicate-events-section';

export function MergedEventsTabNewEvent(): React.ReactElement {
    const selectedLocation = useSelectedLocation();
    const { searchForDuplicateEvents } = useEnabledFeatures();
    return (
        <TabBody>
            {searchForDuplicateEvents && (
                <DuplicateEventsSection
                    latitude={selectedLocation?.latitude}
                    longitude={selectedLocation?.longitude}
                    locationId={selectedLocation?.id}
                />
            )}
        </TabBody>
    );
}
